import { useState } from "react";
import { Clapperboard, Loader2, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { FolderSection } from "@/components/FolderSection";

/* FileJump folders scanned for videos (MP4/M4V/MOV/WebM play in the browser; MKV/AVI/WMV/TS are listed as not playable). */
export const VideoFolders = ({ creds, running, onStarted }) => {
  const [busy, setBusy] = useState(false);
  const scan = async () => {
    setBusy(true);
    try { await api.post("/webdav/sync", null, { params: { scope: "videos" } }); onStarted?.(); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <FolderSection id="video-folders" testid="video-folders" creds={creds} endpoint="/webdav/video-folders"
      icon={<Clapperboard size={14} />} title="Video folders"
      description="Videos in these folders appear on the Videos page. MP4, M4V, MOV and WebM play in the browser; other formats are listed but marked not playable."
      scanButton={(
        <button onClick={scan} disabled={busy || running} data-testid="video-folders-scan" data-running={running ? 1 : 0} title="Look for new or changed videos in these folders" className="flex !h-8 items-center gap-2 rounded-full border border-zinc-300 bg-white px-3 text-xs font-medium hover:border-zinc-900 disabled:opacity-60">
          {busy || running ? <Loader2 size={13} className="animate-spin" /> : <RefreshCw size={13} />}{running ? "Scanning…" : "Scan video folders"}
        </button>
      )}
      onSaved={(data, picked) => {
        toast.success(data.folders.length ? `Video folders saved — ${data.folders.length} folder${data.folders.length === 1 ? "" : "s"}` : "Video folders cleared");
        if (picked.length) toast.message("Press “Scan video folders” to import its files.");
      }} />
  );
};
